import { render, staticRenderFns } from "./DocGroup.vue?vue&type=template&id=36aa26f2&scoped=true&lang=pug&"
import script from "./DocGroup.vue?vue&type=script&lang=js&"
export * from "./DocGroup.vue?vue&type=script&lang=js&"
import style0 from "./DocGroup.vue?vue&type=style&index=0&id=36aa26f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa26f2",
  null
  
)

export default component.exports